import React, { useState, useEffect } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Label } from 'recharts';
import { LineChart, Line } from 'recharts';

import { encryptStorage } from '../constant';
/**
 * PC_Lc_04 getLeaveData gets imported from api.js file
 */
import { getDomainData, getLeaveData } from '../service/api';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../components/css/Dashboard-styles.css';

export default function LeaveData(props) {
    /**
     * PC_Lc_02
     * The data , role , domains, filtervalue , filterShow state variable is created for storing the response data
     */

    const [data, setData] = useState([]);

    const [role, setRole] = useState('');

    const [domains, setDomains] = useState([]);

    const [filterValue, setFilterValue] = useState('');

    const [filterShow, setFilterShow] = useState(false);

    const filterObj = {
        domain: '',
        year: '',
    };

    const [filterData, setFilterData] = useState(filterObj);

    const [filterPressed, setFilterPressed] = useState(false);

    /**
     * PC_Lc_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {
        setRole(props.role);

        fetchApi();
    }, []);

    /**
     * PC_Lc_06
     * The fetchApi function in the useEffects gets invoked which inturn call the getLeaveData() function with respective parameters
     */

    const fetchApi = async (dataFilter = '') => {
        let resp;

        if (dataFilter.domain || dataFilter.year) {
            resp = await getLeaveData(dataFilter, props.role);
        } else {
            resp = await getLeaveData('', props.role);
        }

        if (resp?.data?.ResponseData.length > 0) setData(resp?.data?.ResponseData);
        else setData([]);

        const domainDrop = await getDomainData();

        if (domainDrop.data.ResponseData.length) setDomains(domainDrop.data.ResponseData);
    };

    const filterClicked = () => {
        fetchApi(filterData);

        setFilterPressed(true);
    };

    /**
     * PC_Lc_10
     * The response data gets stored in the data variable and passed to the AreaChart
     */

    return (
        <>
            <div className="d-flex justify-content-between" style={{ marginBottom: '-10px' }}>
                <h1 className="tt-bold font-15 p-3">{role == 'Hr Manager' ? `Organization's Leave Trend` : 'Leave Trend'}</h1>
                <div className="dropdown m-2 ">
                    <button
                        className={`btn ${role == 'Hr Manager' ? 'dashboard-filter-btn' : null}  font-12 medium-text`}
                        type="button"
                        // id="dropdownMenuButton125"
                        // data-bs-toggle="dropdown"
                        // aria-expanded="false"

                        onClick={() => {
                            setFilterShow(!filterShow);
                        }}
                    >
                        {filterData.domain && filterPressed && filterData.domain != filterValue
                            ? `${filterValue}`
                            : filterData.domain && filterPressed
                            ? `${filterData.domain}`
                            : role == 'Hr Manager'
                            ? `ALL`
                            : null}
                        <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                    </button>

                    {filterShow ? (
                        <div
                            className="dropdown-menu dashboard-filter-dropdown px-3 py-3"
                            style={{ display: 'block' }}
                            onBlur={(event) => {
                                if (!event.currentTarget.contains(event.relatedTarget)) {
                                    setFilterShow(false);
                                }
                            }}
                        >
                            <div className="d-flex justify-content-between">
                                <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                <button
                                    className="btn p-0"
                                    onClick={() => {
                                        setFilterShow(!filterShow);
                                    }}
                                >
                                    <img src="/Images/Path 38820.svg" />
                                </button>
                            </div>
                            {role == 'Hr Manager' ? (
                                <>
                                    <label className="medium-text font-12 d-flex mb-1">Domain</label>
                                    <select
                                        value={filterData.domain}
                                        onChange={(e) => {
                                            setFilterData((filterData) => ({
                                                ...filterData,
                                                [e.target.name]: e.target.value,
                                            }));
                                        }}
                                        className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                        name="domain"
                                    >
                                        <option selected value="">
                                            Select
                                        </option>
                                        {domains.map((domain) => {
                                            return <option value={domain}>{domain}</option>;
                                        })}
                                    </select>
                                </>
                            ) : null}

                            {/* <div className="d-flex justify-content-between">
                            <h5 className="font-12 bold-text mt-3">Date Range</h5>
                        </div> */}
                            <label className="medium-text font-12 d-flex mb-1">Year</label>

                            <DatePicker
                                selected={filterData.year}
                                onChange={(e) => {
                                    setFilterData((filterData) => ({
                                        ...filterData,

                                        ['year']: e,
                                    }));
                                }}
                                name="year"
                                showYearPicker
                                value={filterData.year}
                                className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                dateFormat="yyyy"
                                placeholderText="Select Year"
                            />

                            {/* <input type="date" className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1" placeholder="Select Domain" /> */}
                            <div className="d-flex justify-content-end mt-3">
                                <button
                                    onClick={() => {
                                        setFilterData(filterObj);
                                        fetchApi();
                                        setFilterPressed(false);
                                        setFilterShow(!filterShow);
                                    }}
                                    className="btn hive-btn-secondary me-3"
                                >
                                    Clear
                                </button>
                                <button
                                    autoFocus
                                    onClick={(e) => {
                                        filterClicked(e);
                                        setFilterValue(filterData.domain);
                                        setFilterShow(!filterShow);
                                    }}
                                    type="button"
                                    className="btn hive-btn-primary dashboard-btn-filter"
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="text-center position-relative">
                {/* <span className="yaxis-style">Percentage</span>

                <span className="xaxis-style-new">Time Period</span> */}

                {/* <AreaChart width={510} height={300} data={data}>
                    <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#FFEED3" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#FFEED3" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <XAxis
                        dataKey="name"
                        padding={{ left: 30, right: 30 }}
                        style={{
                            fontSize: '12px',
                            fontFamily: 'SF Pro Regular',
                            color: '#959595',
                        }}
                    > */}
                {/* <Label value="Evaluation Period" offset={0} position="insideBottom" style={{
                        fontSize: '12px',
                        fontFamily: 'SF Pro Regular',
                        color: "#959595"
                    }} /> */}
                {/* </XAxis>
                    <YAxis
                        style={{
                            fontSize: '12px',
                            fontFamily: 'SF Pro Regular',
                            color: '#959595',
                        }}
                    > */}
                {/* <Label value='percentage' offset={5} angle="-90" position='insideLeft' style={{
                        fontSize: '12px',
                        fontFamily: 'SF Pro Regular',
                        color: "#959595"
                    }} /> */}
                {/* </YAxis>
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Area
                        type="monotone"
                        dataKey="percentage"
                        stroke="#F29B10"
                        fillOpacity={1}
                        fill="url(#colorUv)"
                        activeDot={{ r: 8 }}
                        isAnimationActive={true}
                    /> */}
                {/* <Area type="monotone" dataKey="pv" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" /> */}
                {/* </AreaChart> */}
                <div className="db-widget-x-scrl">
                    <LineChart width={510} height={300} data={data} className="db-widget-x-scrl">
                        <XAxis
                            dataKey="name"
                            padding={{ left: 30, right: 30 }}
                            style={{
                                fontSize: '12px',

                                fontFamily: 'SF Pro Regular',

                                color: '#959595',
                            }}
                            label={{ value: 'Time Period', dx: 5, dy: 10, fontSize: 12, fontFamily: 'SF Pro Regular', fill: '#959595',  color: '#959595' }}
                        ></XAxis>

                        <CartesianGrid strokeDasharray="3 3" />

                        <YAxis
                            label={{
                                value: 'Percentage',
                                angle: -90,
                                position: 'insideLeft',
                                dx: 5,
                                dy: 80,
                                fontSize: 12,
                                fontFamily: 'SF Pro Regular',
                                fill: '#959595',
                                color: '#959595'
                            }}
                            style={{
                                fontSize: '12px',

                                fontFamily: 'SF Pro Regular',
                            }}
                        ></YAxis>

                        <Line dataKey="Percentage" stroke="#F29B10" activeDot={{ r: 8 }} isAnimationActive={false} />

                        <Tooltip />

                        {/* <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
                    </LineChart>
                </div>
            </div>
        </>
    );
}
